module.exports = __webpack_public_path__ + "static/media/programming.83d64fec.svg";